import React from 'react';
import { ListItemText, Tooltip, Typography } from '@material-ui/core';
import { birthday } from '../../../../model/birthday';

export const BirthdayInfo = (props: { birthday: birthday, classes: any }) => {
    const { birthday } = props;

    let text = '';
    if (birthday.name)
        text = `${birthday.surname} ${birthday.name}`;

    return <Tooltip title=''>
        <div style={{ display: 'flex'}}>
            <ListItemText primary={text} primaryTypographyProps={{ noWrap: true, variant: 'body1', style: { display: 'block' } }} />
            <Typography style={{ margin: '4px', paddingLeft: '10px' }}>{birthday.age} anni</Typography>
            <Typography style={{ margin: '4px', paddingLeft: '10px' }}>il {birthday.natoil}</Typography>
            <Typography style={{ margin: '4px', paddingLeft: '10px' }}>mail: {birthday.email} | telefono: {birthday.tel} </Typography>
        </div>
    </Tooltip>
}